import { Privilege} from 'models/BaseModel'
import { Code } from 'constants/codes';
import { Utility } from 'helpers/UtilityHelpers';
import CryptoJS from 'crypto-js';

const PrivilegeAny = (formNo: number, Privilege: number ): boolean => {
  var PrivilegeList = Utility.Storage.GetSecure(Code.LocalKey.PrivilegeList);
  console.log(PrivilegeList);
  if(PrivilegeList) {
    return PrivilegeList.includes(`${formNo}${Privilege}`);
  }
  return false;
};

const PrivilegeAll = (formNo: number ): boolean => {
  return PrivilegeAny(formNo,Code.Privilege.ALL);
};

const PrivilegeView = (formNo: number ): boolean => {
  return PrivilegeAny(formNo,Code.Privilege.VIEW);
};

const PrivilegeOpen = (formNo: number ): boolean => {
  return PrivilegeAny(formNo,Code.Privilege.OPEN);
};

const PrivilegeCreate = (formNo: number ): boolean => {
  return PrivilegeAny(formNo,Code.Privilege.CREATE);
};

const PrivilegeModify = (formNo: number ): boolean => {
  return PrivilegeAny(formNo,Code.Privilege.MODIFY);
};

const PrivilegeDelete = (formNo: number ): boolean => {
  return PrivilegeAny(formNo,Code.Privilege.DELETE);
};

const PrivilegePrint = (formNo: number ): boolean => {
  return PrivilegeAny(formNo,Code.Privilege.PRINT);
};

const PrivilegeExport = (formNo: number ): boolean => {
  return PrivilegeAny(formNo,Code.Privilege.EXPORT);
};

const PrivilegeApprove = (formNo: number ): boolean => {
  return PrivilegeAny(formNo,Code.Privilege.APPROVE);
};

const PrivilegeAdvance = (formNo: number ): boolean => {
  return PrivilegeAny(formNo,Code.Privilege.ADVANCE);
};

const PrivilegeAdmin = (formNo: number ): boolean => {
  return PrivilegeAny(formNo,Code.Privilege.ADMIN);
};

const PrivilegeList = (formNo: number): Privilege => {
  const privilegeList = Utility.Storage.GetSecure(Code.LocalKey.PrivilegeList);

  //console.log("Privilege List:", privilegeList);

  if (!privilegeList) {
    return { ALL: false, VIEW: false, OPEN: false, CREATE: false, MODIFY: false, DELETE: false, PRINT: false, CALL: false, EMAIL: false, FAX: false, EXPORT: false, APPROVE: false, HISTORY: false, EXPERT: false, ADMIN: false };
  }

  if(privilegeList.includes("0000")) {
    return { ALL: true, VIEW: true, OPEN: true, CREATE: true, MODIFY: true, DELETE: true, PRINT: true, CALL: true, EMAIL: true, FAX: true, EXPORT: true, APPROVE: true, HISTORY: true, EXPERT: true, ADMIN: true };
  }

  return {
    ALL: privilegeList.includes(`${formNo}${Code.Privilege.ALL}`),
    VIEW: privilegeList.includes(`${formNo}${Code.Privilege.VIEW}`),
    OPEN: privilegeList.includes(`${formNo}${Code.Privilege.OPEN}`),
    CREATE: privilegeList.includes(`${formNo}${Code.Privilege.CREATE}`),
    MODIFY: privilegeList.includes(`${formNo}${Code.Privilege.MODIFY}`),
    DELETE: privilegeList.includes(`${formNo}${Code.Privilege.DELETE}`),
    PRINT: privilegeList.includes(`${formNo}${Code.Privilege.PRINT}`),
    CALL: privilegeList.includes(`${formNo}${Code.Privilege.CALL}`),
    EMAIL: privilegeList.includes(`${formNo}${Code.Privilege.EMAIL}`),
    FAX: privilegeList.includes(`${formNo}${Code.Privilege.FAX}`),
    EXPORT: privilegeList.includes(`${formNo}${Code.Privilege.EXPORT}`),
    APPROVE: privilegeList.includes(`${formNo}${Code.Privilege.APPROVE}`),
    HISTORY: privilegeList.includes(`${formNo}${Code.Privilege.HISTORY}`),
    EXPERT: privilegeList.includes(`${formNo}${Code.Privilege.ADVANCE}`),
    ADMIN: privilegeList.includes(`${formNo}${Code.Privilege.ADMIN}`),
  };
};

const SpecialList = (): string => {
  const specialList = Utility.Storage.GetSecure(Code.LocalKey.SpecialList);

  return specialList;
};

const ReportList = (): string => {
  const reportList = Utility.Storage.GetSecure(Code.LocalKey.ReportList);

  return reportList;
};

const secretKey = "J!z9xYp&8bR%lMwZ"; // Must match C#
const iv = CryptoJS.enc.Utf8.parse("1234567890123456"); // Must match C#

// Encrypt function
export const encrypt = (text: string): string => {
  const key = CryptoJS.enc.Utf8.parse(secretKey.padEnd(32, " ")); // Match 32 bytes
  const ciphertext = CryptoJS.AES.encrypt(text, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  }).toString();
  return ciphertext;
};

// Decrypt function
export const decrypt = (ciphertext: string): string => {
  const key = CryptoJS.enc.Utf8.parse(secretKey.padEnd(32, " ")); // Match 32 bytes
  const bytes = CryptoJS.AES.decrypt(ciphertext, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  return bytes.toString(CryptoJS.enc.Utf8);
};



export const Security = {
  Privilege: {
    List : PrivilegeList,
    Any : PrivilegeAny,
    All : PrivilegeAll,
    View : PrivilegeView,
    Open : PrivilegeOpen,
    Create : PrivilegeCreate,
    Modify : PrivilegeModify,
    Delete : PrivilegeDelete,
    Print : PrivilegePrint,
    Export : PrivilegeExport,
    Approve : PrivilegeApprove,
    Advance : PrivilegeAdvance,
    Admin : PrivilegeAdmin,
    Special : SpecialList,
    Report : ReportList,
  },
  Cipher:{
    encrypt: encrypt,
    decrypt: decrypt,
  }
}